const PINNED_RETAIL_NAMES: ReadonlySet<string> = new Set([
  "實體-全聯",
  "實體-寶雅",
  "B2C-迪卡儂",
  "B2B-蝦皮寄倉",
  "B2B-MOMO",
  "B2B-酷澎",
]);

/**
 * 將零售商選項依照指定名單置頂排序，其餘維持原順序排在後面
 * @param options - 零售商選項清單，每個選項需包含 label
 * @returns 置頂名單排在前面、其餘選項在後的新陣列
 */
export default function sortRetailByPinned<T extends { label: string }>(options: T[]): T[] {
  const pinned = options.filter((o) => PINNED_RETAIL_NAMES.has(o.label));
  const rest = options.filter((o) => !PINNED_RETAIL_NAMES.has(o.label));
  return [...pinned, ...rest];
}
